import Axios from 'axios';

import { ZepQuizApiError } from '@/api/httpClient';

export const isZepQuizApiError = (error: unknown): error is ZepQuizApiError => {
  return error instanceof ZepQuizApiError;
};

export const validateZepQuizApiErrorStatus = (
  error: unknown,
  statusList: string[],
) => {
  if (isZepQuizApiError(error)) {
    return {
      isError: statusList.includes(error.status),
      status: error.status,
      serverMessage: error.message,
    };
  }
};

// 더 명확한 이름의 헬퍼 함수들
export const matchesApiErrorStatus = (
  error: unknown,
  status: string | string[],
): boolean => {
  if (!isZepQuizApiError(error)) return false;
  const statusList = Array.isArray(status) ? status : [status];
  return statusList.includes(error.status);
};

/** HTTP 상태 코드. `ZepQuizApiError` 는 자기 필드를, 그 밖의 axios 오류는 응답의 것을 읽는다. */
export const getApiErrorHttpStatus = (error: unknown): number | undefined => {
  if (isZepQuizApiError(error)) return error.httpStatus;
  if (Axios.isAxiosError(error)) return error.response?.status;
  return undefined;
};

export const getApiErrorStatus = (error: unknown): string | undefined => {
  if (isZepQuizApiError(error)) {
    return error.status;
  }
  return undefined;
};
